import {
  DropdownMenu,
  DropdownMenuItem,
  SelectItem,
  SelectValueType,
  Text,
} from "@skailer-com/uikit";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

export interface DropdownMultiSelectProps {
  onChange: (values: SelectValueType[]) => void;
  values: SelectValueType[];
  options: SelectItem[];
  showCaption?: boolean;
  selectedEmptyValue?: string;
}

export const NotificationSettingComponent = ({
  values,
  options,
  onChange,
  showCaption = true,
  selectedEmptyValue,
}: DropdownMultiSelectProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const selectedOptions = useMemo(
    () => options.filter((option) => values.includes(option.id)),
    [values, options]
  );

  const toggleValue = (id: SelectValueType) => {
    const newValues = values.includes(id) ? values.filter((v) => v !== id) : [...values, id];
    onChange(newValues);
  };

  return (
    <DropdownMenu
      closeOnClick={false}
      open={isOpen}
      onOpenChange={setIsOpen}
      placement={"bottom-end"}
      trigger={
        <Text className="underline text-default cursor-pointer hover:no-underline whitespace-nowrap">
          {selectedOptions.length > 0
            ? selectedOptions.map((opt) => opt.title).join(", ")
            : selectedEmptyValue
              ? selectedEmptyValue
              : t("common:no")}
        </Text>
      }
    >
      {options.map((option, optionIndex) => (
        <DropdownMenuItem
          key={`${optionIndex}`}
          title={option.title}
          description={showCaption ? option.caption : undefined}
          isSelected={values.includes(option.id)}
          onClick={() => {
            toggleValue(option.id);
          }}
        />
      ))}
    </DropdownMenu>
  );
};
